import AppForm from '../app-components/Form/AppForm';

Vue.component('app-finance-credit-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                // admin_user_id:  '' ,
                // app_offices_id:  '' ,
                app_factories_id:  '' ,
                name:  '' ,
                type:  'cost' ,
                money:  0 ,
                // rest_money:  '' ,
                created_at:  this.formatDate(new Date(), null, "YYYY-MM-DD hh:mm:ss"),
                
            },
            tempFactory: null,
            tempOffice: null,
            testDate: "2022-11-10 12:00:00",
        }
    },
    methods:{
        onUpdateFactory(appFactory) {
            if (appFactory !== null) {
                this.form.app_factories_id = appFactory.id;
            }else{
                this.form.app_factories_id = "";
            }
        },
        onRemoveFactory(appFactory) {
            this.form.app_factories_id = "";
        },
        onSelect(appFactory) {
            if (appFactory !== null) {
                this.form.app_offices_id = appFactory.id;
            }else{
                this.form.app_offices_id = null;
            }
        },
        onRemove(appFactory) {
            this.form.app_offices_id = null;
        },
    },
    props:{
        selectedFactory: {
            type: Object,
            default: () => {}
        },
        selectedOffice: {
            type: Object,
            default: () => {}
        },
        enableDateCreate: {
            type: Boolean,
            default: true
        },
        debtFinances: {
            type: Array,
            default: () => []
        },
    },
    mounted: function () {  
        this.tempFactory = this.selectedFactory
        this.tempOffice = this.selectedOffice
        // console.log('this.formatDate(this.form.created_at)', this.formatDate(this.form.created_at))
        // console.log('this.formatDate(this.form.created_at) || this.formatDate(new Date())', this.formatDate(this.form.created_at) || this.formatDate(new Date(), null, "YYYY-MM-DD hh:mm:ss"))
        // this.form.created_at = this.formatDate(this.form.created_at)|| this.formatDate(new Date())
        // console.log('this.form.created_at', this.form.created_at)
    },

});